import { render, staticRenderFns } from "./CommentsComponent.vue?vue&type=template&id=25a2a936"
import script from "./CommentsComponent.vue?vue&type=script&lang=js"
export * from "./CommentsComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentsComponent.vue?vue&type=style&index=0&id=25a2a936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports